// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__LjbK+","intro":"Header_intro__cri3E","brMobile":"Header_brMobile__21XJe"};